import { Component, h } from '@monygroupcorp/microact';
import { MessagePopup } from '../Util/MessagePopup.js';

export class ApprovalModal extends Component {
    constructor(props) {
        super(props);
        console.log('[DEBUG] ApproveModal constructor called with amount:', props.amount, 'and address:', props.userAddress);

        this.blockchainService = props.blockchainService;
        this.eventBus = props.eventBus;
        this.amount = props.amount;
        this.userAddress = props.userAddress;

        this.messagePopup = new MessagePopup('approve-status');
        this.isClosing = false;
        this.modalId = Math.random().toString(36).substring(2, 9);

        this.state = {
            status: 'idle', // idle, pending, success, error
            statusMessage: ''
        };

        console.log(`[DEBUG] ApproveModal instance created with ID: ${this.modalId}`);
    }

    didMount() {
        console.log(`[DEBUG-${this.modalId}] ApproveModal mounted to DOM`);
    }

    async handleApprove() {
        console.log(`[DEBUG-${this.modalId}] Approve button clicked`);
        try {
            this.setState({
                status: 'pending',
                statusMessage: 'Waiting for wallet confirmation...'
            });

            // Get user address if not provided
            if (!this.userAddress) {
                console.log(`[DEBUG-${this.modalId}] No user address provided, attempting to get from signer`);
                if (this.blockchainService && this.blockchainService.signer) {
                    try {
                        this.userAddress = await this.blockchainService.signer.getAddress();
                        console.log(`[DEBUG-${this.modalId}] Retrieved user address for approval: ${this.userAddress}`);
                    } catch (addressError) {
                        console.error(`[DEBUG-${this.modalId}] Failed to get user address for approval:`, addressError);
                        throw new Error('Could not get wallet address for approval. Please reconnect your wallet.');
                    }
                } else {
                    console.error(`[DEBUG-${this.modalId}] No blockchain service or signer available`);
                    throw new Error('No wallet connected. Please connect your wallet first.');
                }
            } else {
                console.log(`[DEBUG-${this.modalId}] Using provided user address: ${this.userAddress}`);
            }

            // Format token amount with 18 decimals
            console.log(`[DEBUG-${this.modalId}] Parsing amount: ${this.amount}`);
            const parsedAmount = this.blockchainService.parseExec(this.amount);
            console.log(`[DEBUG-${this.modalId}] Parsed amount: ${parsedAmount}`);

            // Get router address
            const routerAddress = this.blockchainService.swapRouter?.address || this.blockchainService.swapRouter;
            console.log(`[DEBUG-${this.modalId}] Router address for approval: ${routerAddress}`);

            // Call the standard setApproval method
            console.log(`[DEBUG-${this.modalId}] Approving ${this.amount} EXEC tokens from ${this.userAddress} to ${routerAddress}`);

            this.setState({ statusMessage: 'Transaction submitted, waiting for confirmation...' });

            // Send the approval transaction
            console.log(`[DEBUG-${this.modalId}] Calling blockchainService.setApproval`);
            try {
                const approvalResult = await this.blockchainService.setApproval(routerAddress, parsedAmount);
                console.log(`[DEBUG-${this.modalId}] Approval transaction result:`, approvalResult);
            } catch (txError) {
                console.error(`[DEBUG-${this.modalId}] Transaction error:`, txError);
                throw txError;
            }

            // Update status message
            this.setState({
                status: 'success',
                statusMessage: 'Approval successful!'
            });

            // Wait briefly to show success message
            console.log(`[DEBUG-${this.modalId}] Approval successful, waiting before emitting event`);
            await new Promise(resolve => setTimeout(resolve, 1500));

            // Emit success event
            console.log(`[DEBUG-${this.modalId}] Emitting approve:complete event`);
            this.eventBus.emit('approve:complete');

            // Close modal
            console.log(`[DEBUG-${this.modalId}] Calling handleClose after successful approval`);
            this.handleClose();

        } catch (error) {
            console.error(`[DEBUG-${this.modalId}] Approval failed:`, error);

            let errorMessage = error.message;
            if (errorMessage.includes('Contract call')) {
                const parts = errorMessage.split(': ');
                errorMessage = parts[parts.length - 1];
            }

            this.setState({
                status: 'error',
                statusMessage: `Error: ${errorMessage}`
            });

            this.messagePopup.error(
                `Approval Failed: ${errorMessage}`,
                'Transaction Failed'
            );
        }
    }

    handleClose() {
        console.log(`[DEBUG-${this.modalId}] handleClose called`);
        // Prevent multiple close operations
        if (this.isClosing) {
            console.log(`[DEBUG-${this.modalId}] Already closing, skipping`);
            return;
        }
        this.isClosing = true;

        console.log(`[DEBUG-${this.modalId}] Closing approval modal`);

        try {
            // Remove the modal from the DOM
            if (this.element && this.element.parentNode) {
                console.log(`[DEBUG-${this.modalId}] Removing modal from DOM`);
                this.element.parentNode.removeChild(this.element);
            } else {
                console.warn(`[DEBUG-${this.modalId}] Modal element or parent not found during close`);
            }

            // Emit a closed event
            console.log(`[DEBUG-${this.modalId}] Emitting approveModal:closed event`);
            this.eventBus.emit('approveModal:closed');

            // Clean up any resources
            console.log(`[DEBUG-${this.modalId}] Calling dispose method`);
            this.dispose();
        } catch (error) {
            console.error(`[DEBUG-${this.modalId}] Error closing approval modal:`, error);
        }
    }

    // Properly dispose of the component
    dispose() {
        console.log(`[DEBUG-${this.modalId}] Disposing component resources`);

        // Clear references
        this.isClosing = true;
        this.blockchainService = null;
        this.userAddress = null;
        console.log(`[DEBUG-${this.modalId}] Component disposed`);
    }

    show() {
        console.log(`[DEBUG-${this.modalId}] Show method called`);
        this.isClosing = false;
        if (this.element) {
            this.element.style.display = 'block';
        }
        console.log(`[DEBUG-${this.modalId}] Modal set to display:block`);
    }

    hide() {
        console.log(`[DEBUG-${this.modalId}] Hide method called`);
        if (this.element) {
            this.element.style.display = 'none';
        }
    }

    render() {
        // Get router address directly from the blockchain service instead of the store
        const routerAddress = this.blockchainService.swapRouter?.address || this.blockchainService.swapRouter;
        const formattedAmount = parseInt(this.amount).toLocaleString();
        const { status, statusMessage } = this.state;
        const isApproving = status === 'pending';

        return h('div', {
            className: 'approve-modal-overlay',
            onClick: (e) => {
                if (e.target === e.currentTarget) this.handleClose();
            }
        },
            h('div', { className: 'approve-modal' },
                h('button', {
                    className: 'approve-modal-close',
                    onClick: this.bind(this.handleClose)
                }, '\u00D7'),
                h('div', { className: 'approve-modal-content' },
                    h('h2', null, 'Approve Router'),
                    h('p', null, 'Before selling your $EXEC tokens, you need to approve the router contract to spend them.'),

                    h('div', { className: 'approve-details' },
                        h('div', { className: 'approve-info' },
                            h('span', { className: 'label' }, 'Amount to Approve:'),
                            h('span', { className: 'value' }, `${formattedAmount} $EXEC`)
                        ),
                        h('div', { className: 'approve-info' },
                            h('span', { className: 'label' }, 'Router Address:'),
                            h('span', { className: 'value' }, routerAddress)
                        )
                    ),

                    statusMessage && h('div', {
                        className: `status-message ${status}`
                    }, statusMessage),

                    h('button', {
                        className: 'approve-button',
                        disabled: isApproving,
                        onClick: this.bind(this.handleApprove)
                    }, isApproving ? 'Approving...' : 'Approve')
                )
            )
        );
    }

    static get styles() {
        return `
            .approve-modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.75);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1000;
            }

            .approve-modal {
                background-color: #111;
                border-radius: 8px;
                padding: 24px;
                position: relative;
                width: 90%;
                max-width: 500px;
            }

            .approve-modal-close {
                position: absolute;
                top: 16px;
                right: 16px;
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                color: #fff;
            }

            .approve-modal h2 {
                margin: 0 0 16px 0;
                color: #fff;
            }

            .approve-details {
                background-color: #1a1a1a;
                border-radius: 8px;
                padding: 16px;
                margin: 16px 0;
            }

            .approve-info {
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
                word-break: break-all;
            }

            .approve-info:last-child {
                margin-bottom: 0;
            }

            .approve-info .label {
                color: #888;
                margin-right: 16px;
            }

            .approve-info .value {
                color: #fff;
                text-align: right;
            }

            .approve-button {
                width: 100%;
                padding: 12px;
                background-color: #007bff;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                font-size: 16px;
                margin-top: 16px;
            }

            .approve-button:disabled {
                background-color: #555;
                cursor: not-allowed;
            }

            .approve-button:hover:not(:disabled) {
                background-color: #0056b3;
            }

            .status-message {
                margin-top: 12px;
                padding: 10px;
                border-radius: 4px;
                text-align: center;
                font-size: 14px;
            }

            .status-message.pending {
                background-color: #2c3e50;
                color: #f1c40f;
            }

            .status-message.success {
                background-color: #27ae60;
                color: white;
            }

            .status-message.error {
                background-color: #c0392b;
                color: white;
            }
        `;
    }
}

export default ApprovalModal;
